<template>
<div class="brand-statistics">
    <!-- 按钮和数量显示区域 -->
    <div class="toolbar" v-if="showPartList">
        <div class="quantity-display">
            <el-image :src="`https://huanuowei.cn/images/hnw/web/brand/${currentBrand}.png`" @click.stop>
                <div slot="error" class="image-slot">
                    {{ currentBrand }}
                </div>
            </el-image>
            <span class="quantity-item" :class="{ active: isSale === 2 }" @click="filterBySaleStatus(2)">
                未采: {{ currentBrandData.brand_total - currentBrandData.user_total }}
            </span>
            <span class="quantity-item" :class="{ active: isSale === 1 }" @click="filterBySaleStatus(1)">
                已采: {{ currentBrandData.user_total }}
            </span>
        </div>
        <div class="buttons">
            <el-button class="export-button" @click="exportData" type="primary" size="small">
                导出
            </el-button>
            <el-button class="back-button" @click="backToBrandList"  size="small">
                返回品牌列表
            </el-button>
        </div>
    </div>

    <!-- 品牌列表 -->
    <div v-loading="loading" element-loading-text="正在加载中" v-if="!showPartList">
        <el-row class="brand-list" :gutter="10">
            <el-col  :span="6" v-for="(brand,i) in oenaturebrandList" :key="i">

                <div class="brand-box"  @click="parasChange(brand.oenaturebrand)">
                    <div class="brand-logo">
                        
                        <el-image :src="`https://huanuowei.cn/images/hnw/web/brand/${brand.oenaturebrand}.png`" @click.stop>
                        <div slot="error" class="image-slot">
                            {{ brand.oenaturebrand }}
                        </div>
                        </el-image>
                    
                    </div>
                    
                    <el-row class="brand-data">
                        <el-col :span="10" class="brand-gress">
                            采购金额
                            <span class="num">{{brand.brand_amount}}</span>
                        </el-col>
                        <el-col class="brand-nums">
                            <div>
                                <div>{{brand.brand_total}}</div>
                                <div class="label">总sku</div>
                            </div>
                            <div>
                                <div>{{brand.user_total}}</div>
                                <div class="label">已采</div>
                            </div>
                            <div>
                                <div>{{brand.brand_total - brand.user_total}}</div>
                                <div class="label">未采</div>
                            </div>
                            
                            
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </div>

    <!-- 配件表格 -->
    <div class="part-table" v-loading="loading" element-loading-text="正在加载中" v-if="showPartList">
        <el-table :data="partList" style="width: 100%" border @sort-change="handleSortChange">
            <el-table-column prop="sccode" label="生产码" sortable></el-table-column>
            <el-table-column prop="oecode" label="OE号" sortable></el-table-column>
            <el-table-column prop="goods_name" label="名称" sortable></el-table-column>
            <el-table-column prop="vehicletype" label="适配车型" sortable></el-table-column>
            <!-- <el-table-column prop="oenaturebrand" label="品牌" width="180" sortable></el-table-column> -->
            <el-table-column prop="goods_price" label="价格" width="80" sortable></el-table-column>
            <el-table-column prop="brand_amount" label="总金额" width="140" sortable></el-table-column>
            <el-table-column prop="user_total" label="总数" width="80" sortable></el-table-column>
            <el-table-column label="数量" width="120">
                <template slot-scope="scope">
                    <el-input-number 
                        v-model="scope.row.goods_num" 
                        :min="1" 
                        :max="Number(scope.row.goods_storage) || 999" 
                        size="mini" 
                        style="width: 100px;"
                    ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="joinCart(scope.row)">加入购物车</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <el-pagination
        
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            background
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</div>
</template>

<script>
export default {
    data(){
        return{
            oenaturebrandList:[],
            showPartList: false, // 控制显示品牌列表还是配件列表
            partList: [], // 配件列表数据
            currentBrand: "", // 当前选中的品牌
            currentBrandData: {}, // 当前品牌的数据
            currentPage: 1, // 当前页码
            pageSize: 10, // 每页条数
            total: 0, // 总条数
            sortField: '', // 排序字段
            sortOrder: '', // 排序顺序
            loading: false, // 加载状态
            isSale: null // 销售状态筛选：0未采，1已采，null不限
        }
    },
    props: {
        startTime: {
            type: Number,
            default: Math.floor((Date.now() - 365 * 24 * 60 * 60 * 1000) / 1000) // 365天前
        },
        endTime: {
            type: Number,
            default: () => Math.floor(new Date().getTime()/1000)
        }
    },
    methods:{
        parasChange(brand){
            console.log(brand);
            this.currentBrand = brand;
            // 找到当前品牌的完整数据
            this.currentBrandData = this.oenaturebrandList.find(item => item.oenaturebrand === brand) || {};
            this.getPartList(brand);
        },
        // 导出功能
        exportData(){
            let baseUrl =  this.$axios.defaults.baseURL + "index.php?act=report_center&op=report_list" + "&"  
            baseUrl += `oenaturebrand=${this.currentBrand}`
            baseUrl += `&buyer_id=${this.$store.state.store_id}`
            baseUrl += `&page=1`
            baseUrl += `&limit=9999`
            baseUrl += `&start=${this.startTime}`
            baseUrl += `&end=${this.endTime}`
            
            // 如果有销售状态筛选，则添加到导出参数中
            if (this.isSale !== null) {
                baseUrl += `&is_sale=${this.isSale}`
            }
            
            // 将表格列的属性用逗号拼接起来
            let keys = "oecode,goods_name,sccode,oenaturebrand,brand_amount,user_total"
            baseUrl += `&download=${keys}`
            console.log("baseUrl",baseUrl);
            location.href = baseUrl 
        },
        // 分页相关方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getPartList(this.currentBrand);
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getPartList(this.currentBrand);
        },
        
        // 处理排序变化
        handleSortChange({ column, prop, order }) {
            this.sortField = prop;
            this.sortOrder = order; // 'ascending', 'descending', null
            this.getPartList(this.currentBrand);
        },
        
        // 根据销售状态筛选
        filterBySaleStatus(status) {
            this.isSale = status;
            this.currentPage = 1; // 重置到第一页
            this.getPartList(this.currentBrand);
        },
        
        // 获取配件列表
        async getPartList(brand){
            try {
                this.loading = true; // 开始加载
                const params = {
                   buyer_id: this.$store.state.store_id,
                   start: this.startTime,
                   end: this.endTime,
                   oenaturebrand: brand,
                   page: this.currentPage,
                   limit: this.pageSize
                };
                
                // 如果有排序参数，则添加到请求中
                if (this.sortField && this.sortOrder) {
                    params.sort_k = this.sortField;
                    params.sort_v = this.sortOrder === 'ascending' ? 'asc' : 'desc';
                }
                // 如果有销售状态筛选，则添加到导出参数中
                if (this.isSale !== null) {
                    params.is_sale = this.isSale !== null ? this.isSale : undefined
                }
                const res = await this.$api.getReportList(params);
                // 假设返回的数据在 res.db 中，实际结构可能需要根据接口调整
                this.partList = res.db || [];
                
                // 初始化每行的购物车数量为1
                this.partList.forEach(goods => {
                    // this.$set(item, 'goods_num', 1);
                    goods.goods_price = this.$handlePrice(goods);
                        // 初始化商品数量
                    this.$set(goods, "goods_num", 1);
                    // this.$ha
                });
                
                if (this.currentPage==1) {
                    this.total = res.total || 0;
                }
                this.showPartList = true;
            } catch (error) {
                console.error("获取配件列表失败:", error);
            } finally {
                this.loading = false; // 加载完成
            }
        },
        
        // 返回品牌列表
        backToBrandList() {
            this.showPartList = false;
            this.partList = [];
            this.currentBrand = "";
        },
        async getList(){
            try {
                this.loading = true; // 开始加载
                const res = await this.$api.getReportListNew({
                   buyer_id: this.$store.state.store_id,
                   start: this.startTime,
                   end: this.endTime,
                   page: 1,
                   limit: 1000
                })
                // 放前面
                // 定义需要排在前面的品牌顺序
                const priorityBrands = ['博世', '采埃孚', '法雷奥', '索恩格', '卢卡斯', 'ATI', 'HNW', 'SCAEG'];
                
                // 获取过滤品牌列表
                const exBrands = this.$store.state.exBrands ? this.$store.state.exBrands.split(',') : [];
                
                // 如果有过滤品牌，则过滤品牌列表
                if (exBrands.length > 0) {
                    res.db = res.db.filter(brand => {
                        // 特别处理"卢卡斯"品牌，需要同时检查"卢卡斯"和"Lucas"
                        if (brand.oenaturebrand === '卢卡斯' || brand.oenaturebrand === 'Lucas') {
                            return !exBrands.includes('卢卡斯') && !exBrands.includes('Lucas');
                        }
                        // 其他品牌直接检查是否在过滤列表中
                        return !exBrands.includes(brand.oenaturebrand);
                    });
                }
                
                // 对res.db进行排序，将指定品牌按顺序放到数组前面
                const sortedData = [...res.db].sort((a, b) => {
                    const brandA = a.oenaturebrand;
                    const brandB = b.oenaturebrand;
                    
                    const indexA = priorityBrands.indexOf(brandA);
                    const indexB = priorityBrands.indexOf(brandB);
                    
                    // 如果两个品牌都在优先列表中，按列表顺序排序
                    if (indexA !== -1 && indexB !== -1) {
                        return indexA - indexB;
                    }
                    
                    // 如果只有A在优先列表中，A排在前面
                    if (indexA !== -1) {
                        return -1;
                    }
                    
                    // 如果只有B在优先列表中，B排在前面
                    if (indexB !== -1) {
                        return 1;
                    }
                    
                    // 如果都不在优先列表中，保持原有顺序
                    return 0;
                });
                
                this.oenaturebrandList = sortedData;

            } catch (error) {
                console.error("获取品牌列表失败:", error);
            } finally {
                this.loading = false; // 加载完成
            }
        },
        /**
         * 加入购物车方法
         */
        async joinCart(carItem) {
            try {
                // 检查必要字段是否存在
                if (!carItem.oecode) {
                    this.$erMsg("缺少必要的商品信息");
                    return;
                }

                // 获取商品数量，默认为1
                const quantity = carItem.goods_num || 1;

                // 构造购物车数据
                let carMessage = {
                    goods_id: carItem.goods_id || '', // 如果没有goods_id，可以留空
                    sccode: carItem.sccode || '',
                    oecode: carItem.oecode || '',
                    goods_name: carItem.goods_name || '',
                    goods_price: carItem.goods_price  || '0', // 使用brand_amount作为备选价格
                    goods_num: quantity, // 使用用户选择的数量
                    goods_storage: carItem.goods_storage  || 0, // 使用user_total作为备选库存
                    store_id: this.$store.state.store_id || '',
                    store_name: this.$store.state.store_name || '',
                    cart_type: '1'
                };

                // 调用API加入购物车
                let res = await this.$api.joinCart([carMessage]);
                
                // 根据返回结果显示提示信息
                // if(res) {
                //     this.$suMsg(`已成功将 ${quantity} 件商品加入购物车`);
                // } else {
                //     this.$erMsg("加入购物车失败");
                // }
            } catch (error) {
                console.error("加入购物车异常:", error);
                this.$erMsg("加入购物车时发生错误: " + error.message);
            }
        }
    },
    
    created(){
        this.getList()
    },
    watch: {
        // 监听时间范围变化
        startTime: {
            async handler() {
                await this.getList();
                if(this.showPartList){
                    this.getPartList(this.currentBrand);
                    this.currentBrandData = this.oenaturebrandList.find(item => item.oenaturebrand === this.currentBrand) || {};
                }
            }
        },
        endTime: {
            async handler() {
                await this.getList();
                if(this.showPartList){
                    this.getPartList(this.currentBrand);
                    this.currentBrandData = this.oenaturebrandList.find(item => item.oenaturebrand === this.currentBrand) || {};
                }
            }
        }
    }
}
</script>

<style lang="scss">
.brand-statistics{
    background: #FFFFFF;
    padding: 10px; /* 减小整体内边距 */

    .toolbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px; /* 减小工具栏底部间距 */
        
        .quantity-display {
            font-weight: bold;
            color: #606266;
            display: flex;
            align-items: center;
            img{
                // width: 20px;
                height: 40px;
            }
            .el-image{
                margin-right: 5px;
            }
            .quantity-item {
                cursor: pointer;
                padding: 5px 10px;
                border-radius: 4px;
                margin-right: 10px;
                transition: all 0.3s;
                
                &:hover {
                    background-color: #f0f0f0;
                }
                
                &.active {
                    background-color: #409EFF;
                    color: white;
                }
            }
        }
        
        .buttons {
            .export-button {
                margin-right: 10px;
            }
        }
    }

    .part-table {
        margin-top: 5px; /* 进一步减小表格顶部间距 */
        margin-bottom: 10px; /* 添加底部间距 */
        
        .el-pagination {
            margin-top: 10px; /* 减小分页器顶部间距 */
            text-align: right;
        }
        .cell{
            padding: 0 5px;
        }
        .el-table__cell{
            padding: 4px 0;
        }
    }
    
    .brand-list{
        .brand-box{
            box-shadow: 0px 1px 6px 0px rgba(0,0,0,0.07);
            border-radius: 4px;
            margin-top: 5px;
            padding: 5px 10px;
            cursor: pointer;
            transition: box-shadow 0.3s ease;
            
            &:hover {
                box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.15);
                transform: scale(1.05);
                // border: 1px solid #063376;
            }
            
            .brand-logo{
                overflow: hidden;
                height: 38px;
                margin-bottom: 5px;
                border-bottom: 1px solid #E5E5E5;
                img{
                    width: 68px;
                    position: relative;
                    top: -8px;
                    // left: -10px;
                }
                .image-slot{
                    line-height: 30px;
                }
            }
            .brand-data{
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                // box-shadow: 0 2px 4px rgba(0,0,0,.12), 0 0 6px rgba(0,0,0,.04);
                padding: 10px;
                border-radius: 4px;
                
                .brand-gress{
                    color: #063376;
                    font-weight: bold;
                    .num {
                        display: block;
                        font-size: 16px;
                        margin-top: 4px;
                    }
                }
                .brand-nums{
                    padding-left: 15px;
                    display: flex;
                    justify-content: space-between;
                    >div{
                        text-align: center;
                        margin-right: 15px;
                        .label{
                            position: relative;
                            top: -2px;
                            margin-left: 5px;
                            margin-top: 4px;
                            color: #999;
                            font-size: 12px;
                        }
                    }
                    >div:last-child{
                        margin-right: 0;
                    }
                }
            }
        }
    }
}
</style>